/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["cui-navbar-panel[_ngcontent-%COMP%]{background-color:#fff;padding:0 1rem 1rem;max-height:272px;overflow:auto}cui-navbar-panel[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font-size:18px;font-weight:700;margin:1rem 0 .25rem;color:#4a4a4a}cui-navbar-panel[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{font-size:16px;font-weight:300;color:#4a4a4a;margin:.5rem 0 .25rem}cui-navbar-panel[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{font-size:12px;font-weight:300;color:#4a4a4a;margin:.25rem 0}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/help/user-manual/user-manual.component.scss.shim.ngstyle.js.pre-build-optimizer.js